<app-sidebar>
  <div class="new-request-container">
    <h1>Search</h1>

    <mat-card>
      <mat-card-content>
        <mat-tab-group [(selectedIndex)]="selectedTabIndex">
          <mat-tab label="Search">
            <div class="tab-content">
              <form [formGroup]="requestForm" (ngSubmit)="onSubmit()">
                <div class="id-list-section" formArrayName="idNumbers">
                  <div *ngFor="let ctrl of idNumbers.controls; let i = index" class="id-row">
                    <mat-form-field appearance="outline" class="id-input">
                      <mat-label>ID Number {{ i + 1 }}</mat-label>
                      <input
                        matInput
                        type="text"
                        [formControlName]="i"
                        placeholder="13-digit South African ID number"
                        (paste)="i === 0 && onIdPaste($event)">
                      <mat-hint>13 digits (YYMMDDGSSSCAZ)</mat-hint>
                      <mat-error *ngIf="ctrl?.hasError('invalidId')">
                        idNumber is invalid
                      </mat-error>
                    </mat-form-field>
                    <div class="id-row-actions">
                      <button
                        type="button"
                        mat-icon-button
                        color="warn"
                        (click)="removeIdField(i)"
                        *ngIf="idNumbers.length > 1">
                        <mat-icon>remove</mat-icon>
                      </button>
                      <button
                        type="button"
                        mat-icon-button
                        color="primary"
                        (click)="addIdField()"
                        [disabled]="idNumbers.length >= maxIdNumbers"
                        [matTooltip]="'Add another ID number (max ' + maxIdNumbers + ')'">
                        <mat-icon>add</mat-icon>
                      </button>
                    </div>
                  </div>
                </div>

                <div class="tab-action-row">
                  <button
                    mat-raised-button
                    class="primary-search-button"
                    color="primary"
                    type="submit"
                    [disabled]="!requestForm.valid || !hasAnyIdNumber || isSubmitting">
                    {{ isSubmitting ? 'Search...' : 'Search' }}
                  </button>
                </div>
              </form>
            </div>
          </mat-tab>

          <mat-tab label="File Upload">
            <div class="tab-content">
              <div class="info-text">
                <p>Upload a CSV or Excel (xlsx) file up to 1MB. The first 20 non-empty rows are preserved in order.</p>
              </div>

              <div class="upload-actions">
                <button
                  mat-stroked-button
                  class="choose-file-button"
                  color="primary"
                  type="button"
                  (click)="uploadInput.click()">
                  Choose File
                </button>
                <button
                  mat-stroked-button
                  color="primary"
                  type="button"
                  (click)="toggleUploadExample()"
                  [attr.aria-expanded]="isUploadExampleVisible">
                  {{ isUploadExampleVisible ? 'Hide example' : 'Show example' }}
                </button>
              </div>

              <div class="upload-format-example" *ngIf="isUploadExampleVisible">
                <p class="upload-format-title">Example format (one ID per row, in the same column):</p>
                <img
                  src="assets/upload-id-format-sample.svg"
                  alt="Example spreadsheet layout showing one ID number per row"
                  class="upload-format-image">
              </div>

              <input
                #uploadInput
                class="file-input"
                hidden
                type="file"
                accept=".csv,.xlsx,text/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                (change)="onUploadFileSelected($event)">

              <div class="upload-meta" *ngIf="uploadedFileName">
                <p><strong>File:</strong> {{ uploadedFileName }}</p>
                <p class="upload-status-text">{{ uploadParseStatusMessage }}</p>
              </div>

              <div class="tab-action-row">
                <button
                  mat-raised-button
                  class="primary-search-button"
                  color="primary"
                  type="button"
                  [disabled]="parsedUploadEntries.length < 1 || isSubmitting"
                  (click)="submitUploadedIds()">
                  {{ isSubmitting ? 'Searching...' : 'Search' }}
                </button>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="popia-wait-overlay" *ngIf="isBusyOverlayVisible">
    <div class="popia-wait-modal">
      <mat-spinner diameter="28"></mat-spinner>
      <p>Please wait...</p>
    </div>
  </div>
</app-sidebar>
